import { AffinyEndpoint } from 'affiny-core/modules/api/core/affinyEndpoints/affiny.endpoints';

export const LogoutResource = {
  logout: () =>
    AffinyEndpoint.BaseWithAuthentication.url(`/oauth/access_token/`)
      .delete()
      .res(),
};
